import { configure } from './configureStore'

export const store = configure()
export const action = (type, payload) => store.dispatch({ type, payload })
